import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Input, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { Application } from '../../clients/aasServerClient.generated';
import { fetchTableApplications,fetchTableApplicationsNF } from '../../stores/applications/actionCreators';
import { getTableApplications } from '../../stores/applications/selectors';
import { isLoading } from '../../stores/navigation/selectors';
import { RootState } from '../../stores/store';
import DashboardContainer from '../dashboard/DashboardContainer';
import ViewContainer from '../layout/ViewContainer';
import Table from '../table/Table';
import TableBody from '../table/TableBody';
import TableColumn from '../table/TableColumn';
import TableHead from '../table/TableHead';
import TableToolbar from '../table/TableToolbar';
import ApplicationTableHead from './ApplicationsTableHead';
import ApplicationTableRow from './ApplicationsTableRow';
import ApplicationsToolbar from './ApplicationsToolbar';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    applications: Application[];
    loading: boolean;
    fetchApplications: () => void;
    fetchApplicationsNF: () => void;
    lState : RootState;
}

export class ApplicationsPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);        
        this.props.lState.tables['applications'].search ='';
        this.props.fetchApplicationsNF();
    }

    public render() {
        const t = this.props.translate;
        return (
            <ViewContainer className="table-view">
                <div>
                    <h1>{t('applications.header.applications')}</h1>
                    {this.props.loading ? <Spinner /> : null}
                </div>
                <Table
                    toolbar={<ApplicationsToolbar />}
                    refresh={this.props.fetchApplications}
                    tableKey="applications"
                >
                    <ApplicationTableHead
                        refresh={this.props.fetchApplications}
                        ids={this.props.applications.map((u) => u.id)}
                    />
                    <TableBody>
                        {this.props.applications.map((application, i) => (
                            <ApplicationTableRow key={i} application={application} />
                        ))}
                    </TableBody>
                </Table>
            </ViewContainer >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    applications: getTableApplications(state),
    loading: isLoading(state),
    lState : state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchApplications: () => dispatch(fetchTableApplications()),
    fetchApplicationsNF: () => dispatch(fetchTableApplicationsNF()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ApplicationsPage)));
